import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenDialogComponent } from "./components/loren-dialog/loren-dialog.component";
import { LorenEntityFormModule } from "../loren-entity-form/loren-entity-form.module";

@NgModule({
  declarations: [LorenDialogComponent],
  exports: [LorenDialogComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    LorenEntityFormModule,

    TranslocoModule,
  ],
})
export class LorenDialogModule {}
